import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const SCROLL_THRESHOLD = 400

interface UseScrollToTopReturn {
  visible: boolean
  scrollToTop: () => void
}

export const useScrollToTop = (): UseScrollToTopReturn => {
  const [visible, setVisible] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setVisible(false)
    const root = document.getElementById('root')
    if (!root) return

    const handleScroll = () => {
      setVisible(root.scrollTop > SCROLL_THRESHOLD)
    }

    root.addEventListener('scroll', handleScroll, { passive: true })
    return () => root.removeEventListener('scroll', handleScroll)
  }, [location.pathname])

  const scrollToTop = () => {
    const root = document.getElementById('root')
    if (root) {
      root.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return {
    visible,
    scrollToTop,
  }
}
